import { createAction, props } from '@ngrx/store';
import { ApplicantRequestResponseDto } from '@shared/models/initial-request-dto';

export const showApplicationError = createAction(
    '[App] Show application error',
    props<{ error }>()
);

export const resetApplicationError = createAction(
    '[App] Reset application error'
);

export const showApplicantRequestSuccess = createAction(
    '[App] Show applicant request success',
    props<ApplicantRequestResponseDto>()
);

export const resetApplicantRequestSuccess = createAction(
    '[App] Reset applicant request success'
);

export const freeze = createAction(
    '[App] Freeze'
);

export const unfreeze = createAction(
    '[App] Unfreeze'
);

export const downloadLocalFile = createAction(
    '[App] Download local file',
    props<{ file: File }>()
);

export const downloadRemoteFile = createAction(
    '[App] Download remote file',
    props<{ documentId: number }>()
);

export const downloadRemoteFilesAsZip = createAction(
    '[App] Download remote files as zip',
    props<{ documentIds: number[] }>()
);

export const downloadUrlFile = createAction(
    '[App] Download url file',
    props<{ url: string, title?: string }>()
);
